<template>

<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <VehicleBrandList />
    </div>
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import VehicleBrandList from '@/components/settings/test-registers/vehicleBrands/VehicleBrandsList'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'VehicleBrand',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    VehicleBrandList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addvehiclebrand' })
    }
  }
}
</script>
